namespace Ir.Components.Workbook.Settings.ReportSettings {
    interface IReportSettingsViewModel {
        reportSettingsVM: any,
        config: WorkbookConfig;
        activeTabOrWidget: KnockoutObservable<ITabOrWidget>;
        activeTabItem: KnockoutObservable<SettingTabVM>;
        itemConfig: BaseItemConfig;

        //aggregateOptions: DevExpress.ui.dxSwitch.Properties;
        grandTotalPositionOptions: DevExpress.ui.dxSelectBox.Properties;
        subTotalsPositionOptions: DevExpress.ui.dxSelectBox.Properties;
        rowHeaderLayoutOptions: DevExpress.ui.dxSelectBox.Properties;
        columnFieldsTextOptions: DevExpress.ui.dxSelectBox.Properties;
        grandTotalTextOptions: DevExpress.ui.dxTextBox.Properties;
        subTotalsTextOptions: DevExpress.ui.dxTextBox.Properties;
        showRowCountOptions: DevExpress.ui.dxSwitch.Properties;
        filterZerosOptions: DevExpress.ui.dxSwitch.Properties;
        keepMetricsOptions: DevExpress.ui.dxSwitch.Properties;
        enableSearchBoxOptions: DevExpress.ui.dxSwitch.Properties;
        enableFilterPanelOptions: DevExpress.ui.dxSwitch.Properties;
        showColumnGrandTotalsOptions: DevExpress.ui.dxSwitch.Properties;
        showColumnTotalsOptions: DevExpress.ui.dxSwitch.Properties;
        showRowGrandTotalsOptions: DevExpress.ui.dxSwitch.Properties;
        showRowTotalsOptions: DevExpress.ui.dxSwitch.Properties;
        expandAllColumnsOptions: DevExpress.ui.dxSwitch.Properties;
        expandAllColumnsPrintingOptions: DevExpress.ui.dxSwitch.Properties;
        expandAllRowsOptions: DevExpress.ui.dxSwitch.Properties;
        expandAllRowsPrintingOptions: DevExpress.ui.dxSwitch.Properties;
        showMetricRowsOptions: DevExpress.ui.dxSwitch.Properties;
        glReportOptions: DevExpress.ui.dxSwitch.Properties;
        separateFieldsOptions: DevExpress.ui.dxSwitch.Properties;
        fixedColumnsOptions: DevExpress.ui.dxNumberBox.Properties;
        fontSizeOptions: DevExpress.ui.dxNumberBox.Properties;
    }
    
    export function getViewModel(this: IReportSettingsViewModel, params: any) {
        this.activeTabItem = params.activeTabItem;
        this.config = params.config as WorkbookConfig;
        this.activeTabOrWidget = params.activeTabOrWidget;
        
        let itemConfig = this.activeTabOrWidget().drilldownManager.reportConfigForDrilldown;
        this.itemConfig = itemConfig;

        //this.aggregateOptions = {
        //    value: config.isAggregative as any,
        //    disabled: ko.computed(function () { return config.comparisonFilters() && config.comparisonFilters().length > 0 }) as any
        //};

        this.grandTotalPositionOptions = {
            dataSource: [
                { id: TotalsPositionEnum.None, text: 'None' },
                { id: TotalsPositionEnum.Bottom, text: 'Bottom' },
                { id: TotalsPositionEnum.Top, text: 'Top' }
            ],
            displayExpr: 'text',
            valueExpr: 'id',
            value: itemConfig.totalsPosition,
            width: '80px'
        };

        this.subTotalsPositionOptions = {
            dataSource: [
                { id: TotalsPositionEnum.None, text: 'None' },
                { id: TotalsPositionEnum.Bottom, text: 'Bottom' },
                { id: TotalsPositionEnum.Top, text: 'Top' }
            ],
            displayExpr: 'text',
            valueExpr: 'id',
            value: itemConfig.subtotalsPosition,
            width: '80px'
        };

        this.grandTotalTextOptions = {
            value: itemConfig.grandTotalText as any,
            width: '100px'
        };
        this.subTotalsTextOptions = {
            value: itemConfig.subTotalText as any,
            width: '100px'
        };

        this.showRowCountOptions = {
            value: itemConfig.showReportRowCount as any
        }
        this.filterZerosOptions = {
            value: itemConfig.filterZeros as any
        }
        this.keepMetricsOptions = {
            value: itemConfig.keepMetricsDrillDown as any
        };

        this.fixedColumnsOptions = {
            value: itemConfig.numberFixedColumns as any,
            min: 0,
            max: 100,
            format: '0#',
            showSpinButtons: isMobile() ? false : true,
            width: 55
        };

        this.enableSearchBoxOptions = {
            value: itemConfig.enableSearchBox as any
        };
        this.enableFilterPanelOptions = {
            value: itemConfig.enableFilterPanel as any
        };

        this.fontSizeOptions = {
            value: itemConfig.fontSize as any,
            min: 8,
            max: 36,
            format: '0#px',
            showSpinButtons: isMobile() ? false : true,
            width: 60
        };

        this.rowHeaderLayoutOptions = {
            dataSource: [{ id: 0, text: 'Tree' }, { id: 1, text: 'Standard' }],
            displayExpr: 'text',
            valueExpr: 'id',
            value: itemConfig.pivotConfig.rowHeaderLayoutPivot,
            width: '80px'
        }

        this.columnFieldsTextOptions = {
            dataSource: [
                { id: ColumnFieldsTextPivotEnum.Automatic, text: 'Automatic' },
                { id: ColumnFieldsTextPivotEnum.LineBreak, text: 'Line Break' },
                { id: ColumnFieldsTextPivotEnum.Concatenate, text: 'Concatenate' }
            ],
            displayExpr: 'text',
            valueExpr: 'id',
            value: itemConfig.pivotConfig.columnFieldsText,
            width: 100,
            hint: "Define how the column fields text will be presented."
        }

        this.showColumnGrandTotalsOptions = {
            value: itemConfig.pivotConfig.showColumnGrandTotals as any
        }
        this.showColumnTotalsOptions = {
            value: itemConfig.pivotConfig.showColumnTotals as any
        };
        this.showRowGrandTotalsOptions = {
            value: itemConfig.pivotConfig.showRowGrandTotals as any
        };
        this.showRowTotalsOptions = {
            value: itemConfig.pivotConfig.showRowTotals as any
        };
        this.expandAllColumnsOptions = {
            value: itemConfig.pivotConfig.expandAllColumns as any
        };
        this.expandAllColumnsPrintingOptions = {
            value: itemConfig.pivotConfig.expandAllColumnsPrinting as any
        };
        this.expandAllRowsOptions = {
            value: itemConfig.expandAllRows as any
        };
        this.expandAllRowsPrintingOptions = {
            value: itemConfig.expandAllRowsPrinting as any
        };
        this.showMetricRowsOptions = {
            value: itemConfig.pivotLayout() === PivotLayoutEnum.Vertical,
            onValueChanged(e) {
                itemConfig.pivotLayout(e.value ? PivotLayoutEnum.Vertical : PivotLayoutEnum.Horizontal);
            }
        };

        this.glReportOptions = {
            value: itemConfig.glReport as any
        };
        this.separateFieldsOptions = {
            value: itemConfig.pivotConfig.separateFields as any
        };
    }
}